module.exports = __webpack_public_path__ + "img/hero_image_speaker_messages_mobile.38ebed2.jpg";